var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 206.09 206.09",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#2969B3;}\r\n\t.st2{fill:#222653;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:8;}\r\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:8.1379,8.1379;}\r\n\t.st6{fill:#CDEAE8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.76,51.27c-0.12-0.16-0.24-0.31-0.37-0.46C96.51,50.96,96.63,51.11,96.76,51.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.94,170.85c6.73-3.06,17.73-4.59,33.94-15.29s19.57-8.87,19.87-20.18c0.31-11.31-0.31-9.78-6.11-16.2 c-5.81-6.42-10.4-16.2-10.4-24.46c0-1.39,0.01-3.23,0.02-5.33c0,0,0,0.02,0,0.02s-13.4-13.19-13.86-30.84c0-6.99,0-10.43,0-10.43 s8.94,1.38,12.84-5.27c3.9-6.65,4.47-16.28,6.54-19.49c2.06-3.21,6.53-8.71,25.34-7.68c0,0,18.8-0.46,36.69,21.78 c17.89,22.24,1.61,51.13,0,54.57s-5.83,7.83-5.83,7.83v0c0.12,1.45,0.41,3.35,0.94,5.86c2.45,11.62,10.7,25.68,19.87,28.74 c9.17,3.06,29.96,2.75,47.39,6.11c16.88,3.26,24.29,5.08,28.91,21.86V0H0v179.19C4.26,173.4,4.02,173.54,9.94,170.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.86,47.66c-4.33,0.39-7.75,0.32-10.32,0.89C76.55,48.56,80.27,47.99,83.86,47.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.76,47.58c-0.03,0-0.05,0-0.08,0.01c2.58-0.21,5.03-0.26,7.06,0.15C89.63,47.18,87.29,47.33,84.76,47.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.53,82.24l-2.68,8.15c0.66-1.34,1.26-2.76,1.59-4.2C113.65,85.26,114.05,83.83,114.53,82.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.12,62.99c-0.18,0.07-0.35,0.15-0.53,0.21C61.78,63.13,61.95,63.06,62.12,62.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.59,63.19c0.18-0.05,0.35-0.14,0.53-0.21c0.4-0.18,0.75-0.4,1.02-0.67c3.06-3.06,6.42-5.81,10.39-13.76 c2.57-0.57,5.99-0.51,10.32-0.89c0.28-0.03,0.55-0.05,0.82-0.07c0.03,0,0.05,0,0.08-0.01c2.53-0.26,4.87-0.4,6.99,0.16 c1.78,0.36,3.23,1.06,4.11,2.34c0.15,0.22,0.34,0.46,0.54,0.73c0.12,0.15,0.25,0.29,0.37,0.46c4.94,5.99,21.1,20.83,21.1,20.83 l-3.34,10.14c-0.48,1.59-0.88,3.02-1.1,3.96c-0.32,1.43-0.93,2.86-1.59,4.2l-1.62,4.94c0,0-1.69-0.75-1.24,4.54v0 c0,0,4.22-4.39,5.83-7.83s17.89-32.33,0-54.57C96.93,15.23,78.12,15.69,78.12,15.69c-18.8-1.03-23.27,4.47-25.34,7.68 c-2.06,3.21-2.64,12.84-6.54,19.49c-3.9,6.65-12.84,5.27-12.84,5.27s0,3.44,0,10.43c0.46,17.66,13.86,30.84,13.86,30.84 s0-0.01,0-0.02c0.07-10.37,0.28-27.08,0.28-27.08S57.14,64.65,61.59,63.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.18,140.58c-17.43-3.36-38.22-3.06-47.39-6.11c-9.17-3.06-17.43-17.12-19.87-28.74 c-0.53-2.5-0.81-4.4-0.94-5.86c-0.45-5.29,1.24-4.54,1.24-4.54l1.62-4.94l2.68-8.15l3.34-10.14c0,0-16.16-14.84-21.1-20.83 c-0.13-0.16-0.25-0.31-0.37-0.46c-0.21-0.26-0.39-0.51-0.54-0.73c-0.88-1.28-2.33-1.98-4.11-2.34c-2.03-0.41-4.48-0.36-7.06-0.15 c-0.27,0.02-0.55,0.05-0.82,0.07c-3.58,0.33-7.31,0.89-10.32,0.89c-3.97,7.95-7.34,10.7-10.39,13.76 c-0.27,0.27-0.62,0.49-1.02,0.67c-0.17,0.08-0.34,0.15-0.53,0.21c-4.45,1.46-14.04-0.88-14.04-0.88s-0.21,16.71-0.28,27.08 c-0.01,2.1-0.02,3.94-0.02,5.33c0,8.25,4.59,18.04,10.4,24.46c5.81,6.42,6.42,4.89,6.11,16.2c-0.31,11.31-3.67,9.48-19.87,20.18 s-27.21,12.23-33.94,15.29c-5.93,2.7-5.69,2.55-9.94,8.34v26.9h206.09v-43.65C201.47,145.66,194.06,143.84,177.18,140.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M61.66,138.92c0,0,1.09,1.04,3.29,2.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M72.52,144.09c8.79,2.13,22.94,1.82,42.52-9.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M118.5,131.99c1.09-0.71,2.2-1.45,3.32-2.23"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_33"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_32"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_31"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_30"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_29"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Base"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage2);
export default __webpack_public_path__ + "static/media/image2.55010d9c861de8ddcd361d6bf5463da9.svg";
export { ForwardRef as ReactComponent };